import React from 'react';

const Privacy = () => {
  return (
    <div className="flex">
      <div className="w-64 h-280 p-5 bg-gray-100 p-20">
        <h2 className="font-semibold text-lg mb-5">Privacy</h2>
        <ul className="text-sm">
          <li className="mb-2">
            <a href="/privacypolicy" className="block p-2 bg-[#F37920]">Privacy Policy</a>
          </li>
          <li className="mb-2">
            <a href="/terms" className="block p-2 hover:bg-[#F37920]">Terms and Condition</a>
          </li>
        </ul>
      </div>
      <div className="flex-1 p-5">
        <div className="mb-4">
          <p>With respect to information available from the web pages in this website, neither TRJ nor any of its employees<br/> make any warranty, express or implied, including the warranty of merchantability and fitness for a particular purpose, or <br/> assume any liability or responsibility for the accuracy, completeness, or usefulness of such information.
          <br/>
          <br/>

You acknowledge and agree that all proprietary rights in the information received shall remain the property of TRJ & Associates<br/> Reproduction, redistribution and transmission of any information contained in the web site is strictly prohibited. TRJ & Associates<br/> shall not be liable for any claims or losses of any nature, arising indirectly or directly from use of the data or material on <br/>this site or unauthorized access to this site or otherwise howsoever arising (except to the extent required by law).
<br/>
<br/>

Access to this web site is confirmation that you have understood and accepted these terms.<br/>
<br/>

This privacy statement is subject to change without any notice to the user. Please read the statement each time you visit<br/> the site so that you will be fully informed of the Privacy Policies and Procedures of TRJ & Associates<br/>
<br/>

The purpose of this privacy statement is to inform you, the User of this Site, of the procedures and practices utilized by <br/> TRJ & Associates to keep your personal information private once you access this Site. TRJ & Associates believes that your privacy is <br/> very important. By accessing this site, you, the user, are giving your consent and approval to the privacy practices and<br/> procedured of TRJ & Associates<br/>
<br/>

TRJ & Associates does not sell, rent, or otherwise provide any personally identifiable information about you to any third party.<br/>TRJ & Associates will not knowingly disclose information collected about each User to parties not affiliated with TRJ & Associates unless<br/> required to do so by law. TRJ & Associates does not market to children or knowingly gather information from children for<br/> marketing purposes.<br/>
<br/>

Our privacy statement only addresses the use and disclosure of information that TRJ & Associates may collect from you.<br/> However, you should be aware that persons not associated or affiliated with TRJ & Associates may engage in unauthorized <br/>practices with the purpose of obtaining your personal information. Although TRJ & Associates discourages this type of activity, we <br/>cannot guarantee that it will not occur. The Internet can take on a life of its own and therefore, TRJ & Associates cannot<br/> guarantee against inadvertent or unknowing disclosures of information about you, the User, to others. To the extent<br/> permitted by law, TRJ & Associates disclaims all liability for any inadvertent disclosures.<br/>
<br/>

By accessing this Site, you are giving your consent and approval to our privacy policies. This Privacy statement is <br/>incorporated into and subject to the Terms and Conditions of This Site as though set forth in full. TRJ & Associates, All Rights Reserved – 2024.</p>
<br/>
        </div>
      </div>
    </div>
  );
}

export default Privacy;